import React from 'react';
import Tooltips from '../includes/Tooltips';

export default function BuildPhone(props) {
    const [confirmPhonePlans, setConfirmPhonePlans] = React.useState([])


    React.useEffect(() => {
      if (props.values.confirmPhonePlan.length !== 0) {
        setConfirmPhonePlans(props.values.confirmPhonePlan);
      }

      if (props.confirmPhonePlan.length === 0) {
        props.toggleCheck('phone')
      }

    }, [props.values.confirmPhonePlan]);

    function handleRemove(title) {
        const newList = props.confirmPhonePlan.filter((item) => item.title !== title);
        props.setPhonePlan(newList)
    }
   
    const handleOptionChange= (plan,details,price,type) => {
        let item =  {
            'title': plan,
            'details': details,
            'price': price
        }
        let check = itemInArray(item);
        let currentPhonePlan = props.confirmPhonePlan;

        // if (props.confirmPhonePlan.length === 0) {
        //   props.toggleCheck('phone')
        // }

        if (type == 'remove') {
          console.log('remove')
            handleRemove(item.title);

            if (plan == 'National Calling Plan') {
              props.setPhonePlan([]);
            }

            if (plan !== "Mobile + International Plan") {
              props.toggleCheck('phone');
            }
        } 
        
        if (type == 'add') {

          console.log('add')

           // if phone not yet in broadbandArray, add phone
          if (!props.values.broadbandArray.includes('phone')) {
            console.log('add phone')
              props.setBroadbandArray([...props.values.broadbandArray, 'phone']);
          }

           setConfirmPhonePlans(prevPlans => [...prevPlans, item]);
            props.setPhonePlan(item)
            
          

           
        }
    }

    const itemInArray = (item) => {
        let currentPhonePlan = confirmPhonePlans;
        if (currentPhonePlan.some(phonePlan => phonePlan.title === item.title)) {
            return true
        } else {
            return false
        }
    }


    const displayPhoneItems = () => {
      let phonePlans = props.values.phonePlans;

      //console.log(props.values);

      if (phonePlans instanceof Array && phonePlans.length !== 0) {
          const plans = [].concat(phonePlans)
              .map((object, i) => {
                // Check if the title is "Mobile + International Plan" and if "National Calling Plan" is not in confirmPhonePlan
                if (object.title === "Mobile + International Plan" && !props.values.confirmPhonePlan.some(plan => plan.title === "National Calling Plan")) {
                  return null; // Do not render this item
                }
                return (
                  <li key={i} style={{ marginTop: object.title === "Mobile + International Plan" ? '10px' : '0' }}>
                    <div className={`broadband-item ${!props.values.confirmPhonePlan.some(plan => plan.title === object.title) ? '' : 'broadband-phone-item toggled'}`}>
                      <div className="broadband-item-detail">
                        <div className="broadband-item-detail--title">
                          {object.title}  {object.title === "Mobile + International Plan" && 
                            <Tooltips values={{ userClassTooltips: "<div class='broadband-tooltip'>Countries included in our Mobile + International Phone Package - Australia, Argentina, Canada, China, Cyprus, France, Germany, Hong Kong, India, Japan, Korea Republic, Luxembourg, Mexico, Netherlands, Pakistan, Singapore, South Africa, Switzerland, Taiwan, United Kingdom, USA. Calling rates to countries outside of this package.</div>" }} placement='right' />
                          }
                        </div>
                        <div dangerouslySetInnerHTML={{__html: object.details}}></div>
                      </div>
                      <div className="broadband-item-price-group">
                        <span className="broadband-item-price">
                          {object.price}<span className="broadband-item-price--small">/month</span>
                        </span>
                        {
                          !props.values.confirmPhonePlan.some(plan => plan.title === object.title) ? <span className="broadband-item-link" onClick={(e)=>handleOptionChange(object.title,object.details,object.price,'add')}>
                            {object.title === "Mobile + International Plan" ? "Add Plan" : "Choose Plan"}
                          </span> : <span className="broadband-item-link" onClick={(e)=>handleOptionChange(object.title,object.details,object.price,'remove')}>
                          Added
                        </span>
                        }
                      </div>
                    </div>
                  </li>
                );
              })
          return plans;
      }
    }
    
    return (
        <React.Fragment>
           <ul className="broadband-items">
              {displayPhoneItems()}
            </ul>
        </React.Fragment>
      )
  }